/* Cart add-ons for The Candy Store (added 2026-09-24).
   Capture-phase listeners: the cart drawer stops click bubbling. */
(function () {
  if (window.__tcsCart) return;
  window.__tcsCart = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-tcs-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var card = btn.closest('[data-tcs-card], .tcs-up__card');
    var sel = card && (card.querySelector('input[data-tcs-variant]:checked') || card.querySelector('[data-tcs-upsell-select]'));
    var variantId = Number(sel ? sel.value : btn.getAttribute('data-tcs-upsell-add'));
    btn.disabled = true;
    var label = btn.innerHTML;
    btn.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Could not add');
        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';
        var openDrawer = btn.hasAttribute('data-tcs-open-drawer');
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('theme:update:cart'));
          if (openDrawer) document.dispatchEvent(new CustomEvent('theme:open:cart-drawer'));
        }, openDrawer ? 150 : 450);
        if (openDrawer) {
          setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; btn.disabled = false; }, 2500);
        }
      });
    }).catch(function (err) {
      btn.textContent = (err && err.message ? err.message : 'Error').slice(0, 24);
      setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1800);
    });
  }, true);

  // The theme only opens the drawer on this event when a JS setting is present,
  // which this theme never sets. Open it ourselves if it did not open.
  document.addEventListener('theme:open:cart-drawer', function () {
    setTimeout(function () {
      try {
        var m = window.Alpine && Alpine.store('modals');
        if (m && m.modals && m.modals.cart && !m.isOpen('cart')) m.open('cart');
      } catch (err) {}
    }, 60);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    var opt = null;
    if (t.matches('[data-tcs-upsell-select]')) opt = t.options[t.selectedIndex];
    else if (t.matches('input[data-tcs-variant]')) opt = t;
    if (!opt) return;
    var card = t.closest('[data-tcs-card], .tcs-up__card');
    var price = card && card.querySelector('[data-tcs-upsell-price]');
    if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
  }, true);
})();
